import { render, staticRenderFns } from "./VpsServer.vue?vue&type=template&id=19c65372&"
import script from "./VpsServer.vue?vue&type=script&lang=js&"
export * from "./VpsServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports